/** Public SyberKey marketing assets (same as syberkey-site navbar). */
export const SYBERKEY_KEY_IMG =
  'https://syberkey.com/images/Gold_key_with_fingerprint_design_no_bg.png';
export const SYBERKEY_WORDMARK_IMG =
  'https://syberkey.com/images/syberkey_logo_no_bg.png';
